var _path, _path2, _path3, _path4, _path5;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgExportGray(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.375 2.375H16.625",
    stroke: "#8D8D8D",
    strokeWidth: 1.2,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.95833 2.375H15.0417V14.1506C15.0417 14.1873 15.0417 14.2056 15.0375 14.2229C15.0338 14.2382 15.0278 14.2528 15.0196 14.2662C15.0103 14.2814 14.9973 14.2944 14.9714 14.3203L12.737 16.5547C12.711 16.5806 12.698 16.5936 12.6829 16.6029C12.6695 16.6111 12.6549 16.6172 12.6395 16.6209C12.6223 16.625 12.6039 16.625 12.5673 16.625H7.15833C6.03823 16.625 5.47817 16.625 5.05035 16.407C4.67403 16.2153 4.36807 15.9093 4.17632 15.533C3.95833 15.1052 3.95833 14.5451 3.95833 13.425V2.375Z",
    stroke: "#8D8D8D",
    strokeWidth: 1.2,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.0833 16.6248V12.8165C11.0833 12.7337 11.1505 12.6665 11.2333 12.6665H15.0417",
    stroke: "#8D8D8D",
    strokeWidth: 1.2,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9.5 10.2915V5.5415",
    stroke: "#8D8D8D",
    strokeWidth: 1.2,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M7.125 7.9165L9.39393 5.64757C9.45251 5.58899 9.54749 5.58899 9.60607 5.64757L11.875 7.9165",
    stroke: "#8D8D8D",
    strokeWidth: 1.2,
    strokeLinecap: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgExportGray);
export default __webpack_public_path__ + "static/media/export-gray.b6bf26a9d893f2a0a8732fd964064c40.svg";
export { ForwardRef as ReactComponent };